import axios from 'axios';

export * from './kcp';

export const axiosInstance = axios.create({
    withCredentials: true
});
